import { render } from "./PostView.vue?vue&type=template&id=a987a4d6&scoped=true"
import script from "./PostView.vue?vue&type=script&lang=js"
export * from "./PostView.vue?vue&type=script&lang=js"

import "./PostView.vue?vue&type=style&index=0&id=a987a4d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a987a4d6"]])

export default __exports__